import React from 'react';
import WorkflowOverview from './WorkflowOverview';

function CoreWorkflow() {
  return (
    <div id="workflow" className="tabcontent">
      <WorkflowOverview />
    </div>
  );
}

export default CoreWorkflow;
